var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-dialog',{attrs:{"custom-class":"with-title","title":_vm.setTitle,"visible":_vm.visible,"before-close":_vm.close},on:{"update:visible":function($event){_vm.visible=$event}}},[(_vm.mode === 'settings')?_c('LotteryPageTable'):(_vm.mode === 'edit_win')?_c('LotteryPageWin'):_c('LotteryPageLose')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }